import { inject } from '@angular/core';
import { TaApiService } from '@shared/services';
import { PopoverConfig, PopoverConfigFactory, PopoverHandlerConfig } from '../generic-popover.interfaces';
import { defaultCancelAction, defaultConfirmAction } from './default-actions';
import { taTrainingFormPopoverConfig } from '@shared/components/edit-create-form/configs/ta-training.form.popover.config';

export const taTrainingPopoverConfig: PopoverConfigFactory = (
  onSuccess: () => void,
  onCancel: () => void,
  actionHandlers?: Record<string, (popoverConfig: PopoverHandlerConfig, formValue: any) => void | Promise<any>>
): PopoverConfig => {
  const taApiService = inject(TaApiService);

  return {
    width: '650px',
    title: 'Đào tạo trợ giảng',
    dismissable: true,
    styleClass: 'p-fluid',
    formConfig: taTrainingFormPopoverConfig(),
    actions: [defaultCancelAction, defaultConfirmAction],
    actionHandlers,
    handlerConfig: {
      service: taApiService,
      method: 'createTaTraining',
      updateMethod: 'updateTaTraining',
      entityLabel: 'đào tạo trợ giảng',
      commonDataTransform: (formValue: any) => ({
        taId: formValue.taId,
        type: formValue.type,
        courseLevelId: formValue.courseLevelId || null,
        status: formValue.status,
        trainerId: formValue.trainerId || null,
        deadline: formValue.deadline || null,
        note: formValue.note || null
      }),
      updateDataTransform: (formValue: any) => ({
        id: formValue.id
      }),
      initialDataTransform: (rawData: any) => ({
        id: rawData.id,
        taId: rawData.taId,
        type: rawData.type,
        courseLevelId: rawData.courseLevelId,
        status: rawData.status,
        trainerId: rawData.trainerId,
        deadline: rawData.deadline ? new Date(rawData.deadline) : null,
        note: rawData.note
      }),
      onSuccess,
      onCancel
    }
  };
};
